module.exports = __webpack_public_path__ + "static/media/29BDOS24.e6d89a89.jpg";